import React from 'react';
import { hintClass } from './challengeWireFormStyles';
import ChallengeLinkIcon from './ChallengeLinkIcon';

export default function ChallengeMutualSupportLine({ mutualSupport }) {
	if (!mutualSupport?.text) return null;

	if (mutualSupport.variant === 'companion_link' || mutualSupport.variant === 'partner_joining') {
		return (
			<p className={`${hintClass} flex items-start gap-2`}>
				<ChallengeLinkIcon />
				<span>{mutualSupport.text}</span>
			</p>
		);
	}

	return <p className={hintClass}>{mutualSupport.text}</p>;
}
